import React, { useEffect, useState } from "react";
import AmpInput from "../AmpInput/AmpInput";
import SmallHeading from "../AmpSmallHeading/AppSmallHeading";
import "./AmpPhoneNumber.css";

interface AmpPhoneNumberProps {
    phoneNumber?: string;
    name: string;
    id: string;
    readOnly?: boolean;
    asOne?: boolean;
    disabled?: boolean;
}

export default function AmpPhoneNumber(props: AmpPhoneNumberProps) {

    const [phoneAddress, setPhoneAddress] = useState("");
    const [phoneExt, setPhoneExt] =  useState("");

    useEffect(() => {
        if (props.phoneNumber) {
            const formattedPhone = props.phoneNumber.replace(/\D/g,'');
            setPhoneAddress(formattedPhone.substring(0, 10));
            setPhoneExt(formattedPhone.substring(10, 15))
        } else {
            setPhoneAddress("");
            setPhoneExt("")
        }
    }, [props])

    const filter = (input: string, isExt: boolean) => {
        const noChars = input.replace(/\D/g,'');
        if (isExt) {
            return (noChars.substring(0, 5));
        } else {
           return (noChars.substring(0, 10));
        }
    }

    const onInputAddr = (value: string) => {
        const filtered = filter(value, false)
        if (phoneAddress === filtered) {
            return
        }
        setPhoneAddress(filtered)
    }   

    const onInputExt = (value: string) => {
        const filtered = filter(value, false)
        if (phoneExt === filtered) {
            return
        }
        setPhoneExt(filter(value, true))
    }  


    return (
        <div className={`phone-number ${props.asOne && "asone"}`}>
            <AmpInput noTimer={false}  onInput={(e) => onInputAddr(e)} name={props.name} id={props.id} type={"text"} maxLength={10} value={phoneAddress} readOnly={props.readOnly} disabled={props.disabled}/>
            <SmallHeading for={`${props.name}-id`}>EXT.</SmallHeading>
            <AmpInput noTimer={false} onInput={(e) => onInputExt(e)} name={`${props.name}-ext`} id={`${props.id}-ext`} type={"text"} maxLength={5} value={phoneExt} readOnly={props.readOnly} disabled={props.disabled}/>
        </div>
    )
}